import { makeStyles } from '@material-ui/core/styles';

export default makeStyles({
  box: {
    margin: '50px',
  },
});
